import React, { useEffect, useRef, useState } from 'react';
import { View, Image, TouchableOpacity, Animated, ScrollView, StyleSheet, useWindowDimensions, Text as NativeText } from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import { LinearGradient } from 'expo-linear-gradient';
import { useNavigation, useRoute } from '@react-navigation/native';

import Text from '../../components/text';
import FooterLanding from '../../components/footerComponentLanding/customFooter';
import { navigate } from '../../navigation/RootNavigation';
import getPlatformType from '../../helpers/helpers';
import { Header } from './header';
import MainDrawerMenu from './MainDrawer';

const stats = [
  { value: 'All-in-One', label: 'Dashboard to organise documents, alerts and actions in one place.' },
  { value: 'Automated', label: 'Certificate reminders and compliance visibility without the admin overload.' },
  { value: 'Anytime', label: 'Use MyHub from laptop, tablet or mobile whenever work needs attention.' },
];

const features = [
  {
    icon: require('../../assets/images/helloimage1/monitor.png'),
    title: 'All-in-One Dashboard',
    description:
      'Track rent payments, tenant communication and property performance in real time.',
  },
  {
    icon: require('../../assets/images/helloimage1/time-management.png'),
    title: 'Maintenance Requests',
    description:
      'Tenants can submit requests online, you approve, assign vendors and track progress.',
  },
  {
    icon: require('../../assets/images/helloimage1/curriculum-vitae.png'),
    title: 'Compliance & Reporting',
    description:
      'Stay compliant with local laws, regulations and generate easy to read reports.',
  },
];

const benefits = [
  'Track property value and certificate expiry in one dashboard.',
  'Store compliance records, tenancy documents and notes securely.',
  'Manage your portfolio with a cleaner, faster self-serve workflow.',
];

const heroHighlights = ['Rent tracking', 'Compliance ready', 'Mobile friendly'];

const comparisonRows = [
  {

    hubita: { text: 'Transparent pricing', positive: true },
  },
  {

    hubita: { text: 'Real-time updates', positive: true },
  },
  {

    hubita: { text: 'Full landlord control', positive: true },
  },
];

const testimonials = [
  {
    name: 'Hitesh',
    role: 'Property Owner',
    accent: 'I finally feel in control.',
    quoteStart: 'Hubita transformed how I manage my rentals -',
  },
  {
    name: 'Sarah',
    role: 'Portfolio Landlord',
    accent: 'Everything feels simpler now.',
    quoteStart: 'The platform made rent tracking and tenant communication easier -',
  },
  {
    name: 'James',
    role: 'Independent Landlord',
    accent: 'It saves me hours every week.',
    quoteStart: 'From compliance to updates, Hubita brought everything into one flow -',
  },
  {
    name: 'Aisha',
    role: 'Property Investor',
    accent: 'The experience is clear and modern.',
    quoteStart: 'I used to juggle too many tools, but with Hubita -',
  },
  {
    name: 'Daniel',
    role: 'Rental Manager',
    accent: 'I trust the process more.',
    quoteStart: 'The visibility and automation changed the way I run my rentals -',
  },
];

const pricingPlans = [
  {
    name: 'Plan Bronze',
    price: '$000',
    period: '/ year',
    subtitle: 'Anual Subscription',
    gradient: ['#1FA2FF', '#1C8FE5'],
    features: ['Includes', 'Includes', 'Includes', 'Includes', 'Includes', 'Includes'],
  },
  {
    name: 'Plan Silver',
    price: '$000',
    period: '/ year',
    subtitle: 'Anual Subscription',
    gradient: ['#D14DE1', '#B74BDF'],
    features: ['Includes', 'Includes', 'Includes', 'Includes', 'Includes', 'Includes'],
  },
  {
    name: 'Plan Gold',
    price: '$000',
    period: '/ year',
    subtitle: 'Anual Subscription',
    gradient: ['#7450F4', '#8663F2'],
    features: ['Includes', 'Includes', 'Includes', 'Includes', 'Includes', 'Includes'],
  },
];

const faqItems = [
  {
    question: 'How does Hubita help?',
    answer:
      'Hubita brings rent collection, tenant communication, maintenance visibi',
  },
 {
    question: 'How does Hubita help?',
    answer:
      'Hubita brings rent collection, tenant communication, maintenance visibi',
  },
 {
    question: 'How does Hubita help?',
    answer:
      'Hubita brings rent collection, tenant communication, maintenance visibi',
  },
 {
    question: 'How does Hubita help?',
    answer:
      'Hubita brings rent collection, tenant communication, maintenance visibi',
  },
 {
    question: 'How does Hubita help?',
    answer:
      'Hubita brings rent collection, tenant communication, maintenance visibi',
  },

];

const primaryButton = {
  bg: '#2E90FA',
  text: '#FFFFFF',
  borderColor: '#2E90FA',
};

const secondaryButton = {
  bg: '#FFFFFF',
  text: '#153166',
  borderColor: '#D6E0F5',
};

const CTAButton = ({ label, onPress, variant = 'primary', compact = false }) => {
  const theme = variant === 'primary' ? primaryButton : secondaryButton;

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.ctaButton,
        compact && styles.ctaButtonCompact,
        {
          backgroundColor: theme.bg,
          borderColor: theme.borderColor,
        },
      ]}
    >
      <Text
        color={theme.text}
        fontSize={15}
        style={styles.ctaButtonText}
      >
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const FeatureCard = ({ item, isPhone }) => (
  <View style={[styles.featureCard, isPhone && styles.featureCardMobile]}>
    <Image source={item.icon} style={styles.featureIcon} resizeMode="contain" />
    <NativeText style={[styles.featureTitleNative, isPhone && styles.featureTitleNativeMobile]}>
      {item.title}
    </NativeText>
    <NativeText style={[styles.featureDescriptionNative, isPhone && styles.featureDescriptionNativeMobile]}>
      {item.description}
    </NativeText>
  </View>
);

const RevealBlock = ({ visible, children, style, delay = 0, distance = 26 }) => {
  const opacity = useRef(new Animated.Value(0)).current;
  const translateY = useRef(new Animated.Value(distance)).current;
  const hasPlayedRef = useRef(false);

  useEffect(() => {
    if (!visible || hasPlayedRef.current) return;

    hasPlayedRef.current = true;
    Animated.parallel([
      Animated.timing(opacity, {
        toValue: 1,
        duration: 460,
        delay,
        useNativeDriver: true,
      }),
      Animated.timing(translateY, {
        toValue: 0,
        duration: 520,
        delay,
        useNativeDriver: true,
      }),
    ]).start();
  }, [visible, delay, opacity, translateY]);

  return (
    <Animated.View
      style={[
        style,
        {
          opacity,
          transform: [{ translateY }],
        },
      ]}
    >
      {children}
    </Animated.View>
  );
};

const FloatingLoop = ({
  children,
  style,
  delay = 0,
  duration = 3200,
  amplitude = 10,
  scaleAmplitude = 0.02,
}) => {
  const translateY = useRef(new Animated.Value(0)).current;
  const scale = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.delay(delay),
        Animated.parallel([
          Animated.timing(translateY, {
            toValue: -amplitude,
            duration,
            useNativeDriver: true,
          }),
          Animated.timing(scale, {
            toValue: 1 + scaleAmplitude,
            duration,
            useNativeDriver: true,
          }),
        ]),
        Animated.parallel([
          Animated.timing(translateY, {
            toValue: 0,
            duration,
            useNativeDriver: true,
          }),
          Animated.timing(scale, {
            toValue: 1,
            duration,
            useNativeDriver: true,
          }),
        ]),
      ])
    );

    animation.start();
    return () => animation.stop();
  }, [amplitude, delay, duration, scale, scaleAmplitude, translateY]);

  return (
    <Animated.View
      style={[
        style,
        {
          transform: [{ translateY }, { scale }],
        },
      ]}
    >
      {children}
    </Animated.View>
  );
};

export const Hello = () => {
  const [openDrawer, setDrawer] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [activeFaq, setActiveFaq] = useState(0);
  const [activeSection, setActiveSection] = useState('Home');
  const navigation = useNavigation();
  const route = useRoute();
  const layoutType = getPlatformType();
  const { width, height } = useWindowDimensions();
  const scrollRef = useRef(null);
  const activeSectionRef = useRef('Home');
  const scrollFrameRef = useRef(null);
  const scrollYRef = useRef(0);
  const pendingSectionRef = useRef(null);
  const testimonialOpacity = useRef(new Animated.Value(1)).current;
  const testimonialTranslateX = useRef(new Animated.Value(0)).current;
  const testimonialScale = useRef(new Animated.Value(1)).current;
  const floatBadgeOne = useRef(new Animated.Value(0)).current;
  const floatBadgeTwo = useRef(new Animated.Value(0)).current;
  const floatBadgeThree = useRef(new Animated.Value(0)).current;
  const pricingFloatOne = useRef(new Animated.Value(0)).current;
  const pricingFloatTwo = useRef(new Animated.Value(0)).current;
  const pricingFloatThree = useRef(new Animated.Value(0)).current;
  const [scrollY, setScrollY] = useState(0);
  const [beliefSectionY, setBeliefSectionY] = useState(-1);
  const [featureSectionY, setFeatureSectionY] = useState(-1);
  const [comparisonSectionY, setComparisonSectionY] = useState(-1);
  const [pricingSectionY, setPricingSectionY] = useState(-1);
  const [deviceSectionY, setDeviceSectionY] = useState(-1);
  const [faqSectionY, setFaqSectionY] = useState(-1);

  const isPhone = layoutType === 'phone';
  const isTablet = !isPhone && width < 1100;
  const headerHeight = isPhone ? 92 : 118;
  const setScrollViewRef = (ref) => {
    if (!ref) return;
    scrollRef.current = typeof ref.getNode === 'function' ? ref.getNode() : ref;
  };
  const scrollToTop = () => {
    if (scrollRef.current && typeof scrollRef.current.scrollTo === 'function') {
      scrollRef.current.scrollTo({
        y: 0,
        animated: true,
      });
    }

    if (typeof window !== 'undefined' && layoutType === 'web') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };
  const scrollToSection = (sectionY) => {
    if (typeof sectionY !== 'number' || sectionY < 0) {
      return;
    }

    const targetY = Math.max(sectionY - headerHeight - 12, 0);

    if (scrollRef.current && typeof scrollRef.current.scrollTo === 'function') {
      scrollRef.current.scrollTo({
        y: targetY,
        animated: true,
      });
    }

    if (typeof window !== 'undefined' && layoutType === 'web') {
      window.scrollTo({
        top: targetY,
        behavior: 'smooth',
      });
    }
  };
  const scrollToFeatures = () => scrollToSection(featureSectionY);
  const updateActiveSection = (offsetY) => {
    const position = offsetY + headerHeight + 40;
    let nextSection = 'Home';

    if (position >= featureSectionY && featureSectionY >= 0) {
      nextSection = 'Features';
    }

    if (activeSectionRef.current !== nextSection) {
      activeSectionRef.current = nextSection;
      setActiveSection(nextSection);
    }
  };
  const handleScrollPosition = (offsetY) => {
    if (scrollFrameRef.current) {
      cancelAnimationFrame(scrollFrameRef.current);
    }
    scrollFrameRef.current = requestAnimationFrame(() => {
      if (Math.abs(scrollYRef.current - offsetY) > 6) {
        scrollYRef.current = offsetY;
        setScrollY(offsetY);
      }
      updateActiveSection(offsetY);
    });
  };
  const isVisibleOnScroll = (sectionY, ratio = 0.84) => {
    if (sectionY < 0) return false;
    return scrollY + height * ratio >= sectionY;
  };
  const runPendingSectionScroll = (targetSection) => {
    if (!targetSection) return false;

    if (targetSection === 'Home') {
      scrollToTop();
      return true;
    }
    if (targetSection === 'Features' && featureSectionY > 0) {
      scrollToFeatures();
      return true;
    }

    return false;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      Animated.parallel([
        Animated.timing(testimonialOpacity, {
          toValue: 0,
          duration: 220,
          useNativeDriver: true,
        }),
        Animated.timing(testimonialTranslateX, {
          toValue: -18,
          duration: 220,
          useNativeDriver: true,
        }),
        Animated.timing(testimonialScale, {
          toValue: 0.98,
          duration: 220,
          useNativeDriver: true,
        }),
      ]).start(() => {
        setActiveTestimonial((current) => (current + 1) % testimonials.length);
        testimonialTranslateX.setValue(22);
        testimonialScale.setValue(0.98);
        Animated.parallel([
          Animated.timing(testimonialOpacity, {
            toValue: 1,
            duration: 320,
            useNativeDriver: true,
          }),
          Animated.spring(testimonialTranslateX, {
            toValue: 0,
            useNativeDriver: true,
            damping: 14,
            stiffness: 110,
            mass: 0.8,
          }),
          Animated.spring(testimonialScale, {
            toValue: 1,
            useNativeDriver: true,
            damping: 14,
            stiffness: 120,
            mass: 0.8,
          }),
        ]).start();
      });
    }, 3200);

    return () => clearInterval(interval);
  }, [testimonialOpacity, testimonialTranslateX, testimonialScale]);

  useEffect(() => {
    const createLoop = (value, duration, offset = 0) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(offset),
          Animated.timing(value, {
            toValue: 1,
            duration,
            useNativeDriver: true,
          }),
          Animated.timing(value, {
            toValue: 0,
            duration,
            useNativeDriver: true,
          }),
        ])
      );

    const badgeOneLoop = createLoop(floatBadgeOne, 2600, 80);
    const badgeTwoLoop = createLoop(floatBadgeTwo, 3200, 180);
    const badgeThreeLoop = createLoop(floatBadgeThree, 2800, 120);

    badgeOneLoop.start();
    badgeTwoLoop.start();
    badgeThreeLoop.start();

    return () => {
      badgeOneLoop.stop();
      badgeTwoLoop.stop();
      badgeThreeLoop.stop();
    };
  }, [floatBadgeOne, floatBadgeTwo, floatBadgeThree]);

  useEffect(() => {
    const createLoop = (value, duration, offset = 0) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(offset),
          Animated.timing(value, {
            toValue: 1,
            duration,
            useNativeDriver: true,
          }),
          Animated.timing(value, {
            toValue: 0,
            duration,
            useNativeDriver: true,
          }),
        ])
      );

    const loopOne = createLoop(pricingFloatOne, 3400, 120);
    const loopTwo = createLoop(pricingFloatTwo, 3000, 260);
    const loopThree = createLoop(pricingFloatThree, 3600, 180);

    loopOne.start();
    loopTwo.start();
    loopThree.start();

    return () => {
      loopOne.stop();
      loopTwo.stop();
      loopThree.stop();
    };
  }, [pricingFloatOne, pricingFloatTwo, pricingFloatThree]);

  useEffect(() => {
    if (layoutType !== 'web' || typeof window === 'undefined') {
      return undefined;
    }

    const handleWindowScroll = () => {
      handleScrollPosition(window.scrollY || window.pageYOffset || 0);
    };

    handleWindowScroll();
    window.addEventListener('scroll', handleWindowScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleWindowScroll);
      if (scrollFrameRef.current) {
        cancelAnimationFrame(scrollFrameRef.current);
      }
    };
  }, [layoutType, featureSectionY, headerHeight]);

  useEffect(() => {
    const targetSection = route?.params?.scrollToSection;
    if (!targetSection) return;

    pendingSectionRef.current = targetSection;
    let attempts = 0;

    const tryScroll = () => {
      attempts += 1;
      if (runPendingSectionScroll(targetSection)) {
        pendingSectionRef.current = null;
        navigation.setParams({ scrollToSection: undefined });
        return;
      }

      if (attempts < 12) {
        requestAnimationFrame(tryScroll);
      }
    };

    requestAnimationFrame(tryScroll);
  }, [route?.params?.scrollToSection, featureSectionY, navigation]);

  const currentTestimonial = testimonials[activeTestimonial];
  const enableRichMotion = !isPhone;
  const heroCopyTranslateY = enableRichMotion ? Math.min(scrollY * 0.08, 22) : 0;
  const heroCopyOpacity = enableRichMotion ? Math.max(0.2, 1 - scrollY / 320) : 1;
  const heroImageTranslateY = enableRichMotion ? Math.min(scrollY * 0.12, 36) : 0;
  const heroImageScale = enableRichMotion ? Math.max(0.95, 1 - scrollY / 1800) : 1;
  const heroBadgeOneStyle = {
    transform: [
      {
        translateY: floatBadgeOne.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -10],
        }),
      },
    ],
  };
  const heroBadgeTwoStyle = {
    transform: [
      {
        translateY: floatBadgeTwo.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -14],
        }),
      },
    ],
  };
  const heroBadgeThreeStyle = {
    transform: [
      {
        translateY: floatBadgeThree.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -9],
        }),
      },
    ],
  };
  const pricingFloatOneStyle = {
    transform: [
      {
        translateY: pricingFloatOne.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -12],
        }),
      },
    ],
  };
  const pricingFloatTwoStyle = {
    transform: [
      {
        translateY: pricingFloatTwo.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -16],
        }),
      },
    ],
  };
  const pricingFloatThreeStyle = {
    transform: [
      {
        translateY: pricingFloatThree.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -10],
        }),
      },
    ],
  };

  return (
    <View style={styles.screen}>
      <View style={[styles.stickyHeaderWrap, layoutType === 'web' && styles.stickyHeaderWrapWeb]}>
        <Header
          setDrawer={() => setDrawer(true)}
          onHomePress={scrollToTop}
          onFeaturesPress={scrollToFeatures}
          activeSection={activeSection}
        />
      </View>

      <ScrollView
        ref={setScrollViewRef}
        contentContainerStyle={[styles.scrollContainer, { paddingTop: headerHeight }]}
        showsVerticalScrollIndicator={false}
        scrollEventThrottle={16}
        onScroll={(event) => {
          if (layoutType !== 'web') {
            handleScrollPosition(event?.nativeEvent?.contentOffset?.y || 0);
          }
        }}
      >
        <View style={[styles.heroSection, isPhone && styles.heroSectionMobile]}>
          {!isPhone ? <View style={styles.heroBackdrop} /> : null}
          {!isPhone ? <View style={styles.heroBackdropSecondary} /> : null}
          <RevealBlock
            visible
            delay={80}
            style={[
              styles.heroCopy,
              (isPhone || isTablet) && styles.heroCopyMobile,
              {
                opacity: heroCopyOpacity,
                transform: [{ translateY: heroCopyTranslateY }],
              },
            ]}
          >
            <NativeText style={[styles.heroTitleNative, isPhone && styles.heroTitleNativeMobile, isTablet && styles.heroTitleNativeTablet]}>
              Say Hello to Effortless Self-Management
            </NativeText>

            <NativeText style={[styles.heroDescriptionNative, !isPhone && { width: '82%' }]}>
              Take control of your rental property with our all-in-one platform. Manage tenants, rent-collection, and compliance - all in one place.
            </NativeText>

            <View style={[styles.heroActions, isPhone && styles.heroActionsMobile]}>
              <CTAButton label="Get Started" onPress={() => navigate('RegisterScreen')} />
            </View>

          </RevealBlock>

          <RevealBlock
            visible
            delay={180}
            distance={34}
            style={[styles.heroVisual, (isPhone || isTablet) && styles.heroVisualMobile]}
          >
            <View style={[styles.heroArtwork, isPhone && styles.heroArtworkMobile]}>
              <View style={styles.heroBlobLarge} />
              <View style={styles.heroBlobTop} />
              <View style={styles.heroBlobBottom} />
              {!isPhone ? (
                <Animated.View style={[styles.heroFloatingBadge, styles.heroFloatingBadgeBottom, heroBadgeThreeStyle]}>
                  <NativeText style={styles.heroFloatingBadgeText}>Landlord control</NativeText>
                </Animated.View>
              ) : null}
              <Image
                source={require('../../assets/images/helloimage1/hello.png')}
                style={[
                  styles.heroImage,
                  isPhone && styles.heroImageMobile,
                  isTablet && styles.heroImageTablet,
                  {
                    transform: [{ translateY: heroImageTranslateY }, { scale: heroImageScale }],
                  },
                ]}
                resizeMode="contain"
              />
            </View>
          </RevealBlock>
        </View>

        <RevealBlock
          visible={isVisibleOnScroll(beliefSectionY, 0.9)}
          delay={60}
          style={styles.beliefBand}
        >
          <View onLayout={(event) => setBeliefSectionY(event.nativeEvent.layout.y)}>
            <NativeText style={[styles.beliefTitleNative, isPhone && styles.beliefTitleNativeMobile]}>
              We believe landlords shouldn’t have to choose between
            </NativeText>
            <NativeText style={[styles.beliefAccentNative, isPhone && styles.beliefAccentNativeMobile]}>
              control and quality
            </NativeText>
          </View>
        </RevealBlock>

        <View
          style={styles.featureSection}
          onLayout={(event) => setFeatureSectionY(event.nativeEvent.layout.y)}
        >
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={styles.featureScroll}
            contentContainerStyle={[
              styles.featureScrollContent,
              !isPhone && styles.featureScrollContentDesktop,
            ]}
            nestedScrollEnabled
            directionalLockEnabled
          >
            {features.map((item, index) => (
              <RevealBlock
                key={item.title}
                visible={isVisibleOnScroll(featureSectionY, 0.88)}
                delay={index * 90}
              >
                <FeatureCard
                  item={item}
                  isPhone={isPhone}
                />
              </RevealBlock>
            ))}
          </ScrollView>
        </View>

        <View
          style={[styles.comparisonSection, isPhone && styles.comparisonSectionMobile]}
          onLayout={(event) => setComparisonSectionY(event.nativeEvent.layout.y)}
        >
          <RevealBlock
            visible={isVisibleOnScroll(comparisonSectionY, 0.84)}
            delay={80}
            style={[styles.comparisonLeft, (isPhone || isTablet) && styles.comparisonLeftMobile]}
          >
            <Animated.View
              style={{
                opacity: testimonialOpacity,
                transform: [{ translateX: testimonialTranslateX }, { scale: testimonialScale }],
              }}
            >
              <NativeText style={[styles.comparisonQuote, isPhone && styles.comparisonQuoteMobile]}>
                "{currentTestimonial.quoteStart}{' '}
                <NativeText style={styles.comparisonQuoteAccent}>{currentTestimonial.accent}</NativeText>
                "
              </NativeText>

              <View style={styles.comparisonProfile}>
                <View style={styles.comparisonAvatar}>
                  <NativeText style={styles.comparisonAvatarText}>
                    {currentTestimonial.name.charAt(0)}
                  </NativeText>
                </View>
                <View style={styles.comparisonProfileText}>
                  <NativeText style={styles.comparisonName}>{currentTestimonial.name}</NativeText>
                  <NativeText style={styles.comparisonRole}>{currentTestimonial.role}</NativeText>
                </View>
              </View>
            </Animated.View>

            <View style={styles.comparisonDots}>
              {testimonials.map((_, dot) => (
                <View
                  key={dot}
                  style={[
                    styles.comparisonDot,
                    dot === activeTestimonial && styles.comparisonDotActive,
                  ]}
                />
              ))}
            </View>
          </RevealBlock>

          <RevealBlock
            visible={isVisibleOnScroll(comparisonSectionY, 0.84)}
            delay={180}
            style={[styles.comparisonTable, (isPhone || isTablet) && styles.comparisonTableMobile]}
          >
            <View style={styles.comparisonHeaderRow}>
              
              <LinearGradient
                colors={['#A35CE7', '#CC58E3']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={[styles.comparisonHeaderCell, styles.comparisonHeaderCellGradient]}
              >
                <NativeText style={styles.comparisonHeaderTextLight}>Hubita Platform</NativeText>
              </LinearGradient>
            </View>

            {comparisonRows.map((row, index) => (
              <View
                key={`${row.hubita.text}`}
                style={[
                  styles.comparisonBodyRow,
                  index === comparisonRows.length - 1 && styles.comparisonBodyRowLast,
                ]}
              >
           
                <View style={[styles.comparisonBodyCell, styles.comparisonBodyCellRight]}>
                  <NativeText style={[styles.comparisonCellIcon, styles.comparisonCheck]}>✓</NativeText>
                  <NativeText style={styles.comparisonCellText}>{row.hubita.text}</NativeText>
                </View>
              </View>
            ))}
          </RevealBlock>
        </View>
        {/* <View
          style={styles.pricingSection}
          onLayout={(event) => setPricingSectionY(event.nativeEvent.layout.y)}
        >
          {!isPhone ? (
            <>
              <Animated.View style={[styles.pricingFloatBadge, styles.pricingFloatBadgeRight, pricingFloatTwoStyle]}>
                <NativeText style={styles.pricingFloatLabel}>Scale as you grow</NativeText>
              </Animated.View>
              <Animated.View style={[styles.pricingFloatOrb, styles.pricingFloatOrbTop, pricingFloatThreeStyle]} />
              <FloatingLoop delay={140} duration={2600} amplitude={8} style={[styles.pricingFloatMini, styles.pricingFloatMiniLeft]}>
                <View style={styles.pricingFloatMiniInner} />
              </FloatingLoop>
              <FloatingLoop delay={260} duration={3200} amplitude={12} style={[styles.pricingFloatMini, styles.pricingFloatMiniRight]}>
                <View style={[styles.pricingFloatMiniInner, styles.pricingFloatMiniInnerAlt]} />
              </FloatingLoop>
            </>
          ) : null}
          <RevealBlock visible={isVisibleOnScroll(pricingSectionY, 0.84)} delay={60}>
            <NativeText style={[styles.pricingHeading, isPhone && styles.pricingHeadingMobile]}>
              Pricing Plans
            </NativeText>
          </RevealBlock>

          <View style={[styles.pricingGrid, (isPhone || isTablet) && styles.pricingGridMobile]}>
            {pricingPlans.map((plan, index) => (
              <RevealBlock
                key={plan.name}
                visible={isVisibleOnScroll(pricingSectionY, 0.84)}
                delay={120 + index * 90}
              >
                <FloatingLoop
                  delay={index * 180}
                  duration={2800 + index * 320}
                  amplitude={enableRichMotion ? (index === 1 ? 12 : 8) : 0}
                  scaleAmplitude={enableRichMotion ? (index === 1 ? 0.03 : 0.015) : 0}
                >
                  <View
                    style={[
                      styles.pricingCard,
                      isPhone && styles.pricingCardMobile,
                      index === 1 && !isPhone && styles.pricingCardFeatured,
                    ]}
                  >
                    {index === 1 && !isPhone ? (
                      <View style={styles.pricingFeaturedBadge}>
                        <NativeText style={styles.pricingFeaturedBadgeText}>Popular</NativeText>
                      </View>
                    ) : null}

                    <NativeText style={styles.pricingCardTitle}>{plan.name}</NativeText>

                    <View style={styles.pricingAmountRow}>
                      <NativeText style={styles.pricingAmount}>{plan.price}</NativeText>
                      <NativeText style={styles.pricingPeriod}>{plan.period}</NativeText>
                    </View>

                    <NativeText style={styles.pricingSubtitle}>{plan.subtitle}</NativeText>

                    <LinearGradient
                      colors={plan.gradient}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 0 }}
                      style={styles.pricingButton}
                    >
                      <NativeText style={styles.pricingButtonText}>Select Plan</NativeText>
                    </LinearGradient>

                    <View style={styles.pricingList}>
                      {plan.features.map((feature, index) => (
                        <View key={`${plan.name}-${index}`} style={styles.pricingListItem}>
                          <NativeText style={styles.pricingListIcon}>✓</NativeText>
                          <NativeText style={styles.pricingListText}>{feature}</NativeText>
                        </View>
                      ))}
                    </View>
                  </View>
                </FloatingLoop>
              </RevealBlock>
            ))}
          </View>
        </View> */}

        <View
          style={[styles.deviceSection, isPhone && styles.deviceSectionMobile]}
          onLayout={(event) => setDeviceSectionY(event.nativeEvent.layout.y)}
        >
          <RevealBlock
            visible={isVisibleOnScroll(deviceSectionY, isPhone ? 0.35 : 0.84)}
            delay={80}
            style={[styles.deviceImageWrap, (isPhone || isTablet) && styles.deviceImageWrapMobile]}
          >
            <Image
              source={require('../../assets/images/helloimage1/phone.png')}
              style={[styles.deviceImage, isPhone && styles.deviceImageMobile]}
              resizeMode="contain"
            />
          </RevealBlock>

          <RevealBlock
            visible={isVisibleOnScroll(deviceSectionY, isPhone ? 0.35 : 0.84)}
            delay={180}
            style={[styles.deviceContent, (isPhone || isTablet) && styles.deviceContentMobile]}
          >
            <NativeText style={[styles.deviceEyebrow, isPhone && styles.deviceEyebrowMobile]}>
              Manage anywhere.
            </NativeText>
            <NativeText style={[styles.deviceTitle, isPhone && styles.deviceTitleMobile]}>
              Hubita works seamlessly across desktop, tablet and mobile.
            </NativeText>

            <View style={[styles.deviceActions, isPhone && styles.deviceActionsMobile]}>
              <LinearGradient
                colors={['#CC58E3', '#B847DC']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={[styles.devicePrimaryButton, isPhone && styles.devicePrimaryButtonMobile]}
              >
                <TouchableOpacity onPress={() => navigate('RegisterScreen')} activeOpacity={0.9} style={styles.deviceButtonTouch}>
                  <NativeText style={styles.deviceButtonText}>Get Started</NativeText>
                </TouchableOpacity>
              </LinearGradient>

              <LinearGradient
                colors={['#2AA7FF', '#1B90EA']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={[styles.deviceSecondaryButton, isPhone && styles.deviceSecondaryButtonMobile]}
              >
                <TouchableOpacity onPress={() => navigate('ContactUs')} activeOpacity={0.9} style={styles.deviceButtonTouch}>
                  <NativeText style={styles.deviceButtonText}>Contact Us</NativeText>
                </TouchableOpacity>
              </LinearGradient>
            </View>
          </RevealBlock>
        </View>

        {/* <View
          style={[styles.faqSection, isPhone && styles.faqSectionMobile]}
          onLayout={(event) => setFaqSectionY(event.nativeEvent.layout.y)}
        >
          <RevealBlock
            visible={isVisibleOnScroll(faqSectionY, 0.84)}
            delay={80}
            style={[styles.faqContent, (isPhone || isTablet) && styles.faqContentMobile]}
          >
            <NativeText style={[styles.faqHeading, isPhone && styles.faqHeadingMobile]}>
              Frequently Asked Questions
            </NativeText>

            <View style={styles.faqList}>
              {faqItems.map((item, index) => {
                const isOpen = activeFaq === index;

                return (
                  <View key={item.question} style={styles.faqItem}>
                    <TouchableOpacity
                      activeOpacity={0.85}
                      onPress={() => setActiveFaq(isOpen ? -1 : index)}
                      style={styles.faqQuestionRow}
                    >
                      <NativeText style={[styles.faqQuestion, isPhone && styles.faqQuestionMobile]}>
                        {item.question}
                      </NativeText>
                      <NativeText style={styles.faqToggle}>{isOpen ? '−' : '+'}</NativeText>
                    </TouchableOpacity>

                    {isOpen ? (
                      <NativeText style={[styles.faqAnswer, isPhone && styles.faqAnswerMobile]}>
                        {item.answer}
                      </NativeText>
                    ) : null}
                  </View>
                );
              })}
            </View>
          </RevealBlock>

          <RevealBlock
            visible={isVisibleOnScroll(faqSectionY, 0.84)}
            delay={180}
            style={[styles.faqImageWrap, (isPhone || isTablet) && styles.faqImageWrapMobile]}
          >
            <Image
              source={require('../../assets/images/helloimage1/Hubitaprint.png')}
              style={[styles.faqImage, isPhone && styles.faqImageMobile]}
              resizeMode="contain"
            />
          </RevealBlock>
        </View> */}

        <FooterLanding navigation={navigation} />
      </ScrollView>

      <Modal
        isVisible={openDrawer}
        animationIn="slideInRight"
        animationOut="slideOutRight"
        animationInTiming={300}
        animationOutTiming={300}
        coverScreen={false}
        hasBackdrop={false}
        backdropOpacity={0}
        onBackdropPress={() => setDrawer(false)}
        style={styles.drawerModal}
      >
        <View style={[styles.drawerWrap, isPhone && styles.drawerWrapMobile]}>
          <MainDrawerMenu setDrawer={setDrawer} />
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  stickyHeaderWrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 50,
  },
  stickyHeaderWrapWeb: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 999,
  },
  scrollContainer: {
    paddingBottom: 0,
  },
  heroSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 56,
    paddingTop: 26,
    paddingBottom: 30,
    minHeight: 560,
    position: 'relative',
    overflow: 'hidden',
  },
  heroSectionMobile: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingTop: 18,
    paddingBottom: 28,
    minHeight: 'auto',
  },
  heroCopy: {
    flex: 0.95,
    justifyContent: 'center',
    zIndex: 2,
  },
  heroCopyMobile: {
    width: '100%',
  },
  heroBackdrop: {
    position: 'absolute',
    width: 340,
    height: 340,
    borderRadius: 999,
    backgroundColor: 'rgba(204,88,227,0.08)',
    top: -80,
    left: -80,
  },
  heroBackdropSecondary: {
    position: 'absolute',
    width: 420,
    height: 420,
    borderRadius: 999,
    backgroundColor: 'rgba(46,144,250,0.06)',
    right: -120,
    top: 40,
  },
  heroEyebrowNative: {
    fontFamily: 'poppins-medium',
    fontSize: 14,
    lineHeight: 20,
    color: '#7C3AED',
    marginBottom: 14,
    letterSpacing: 0.2,
  },
  heroTitleNative: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 56,
    lineHeight: 62,
    letterSpacing: -1.5,
    color: '#1C2D5A',
    maxWidth: 500,
  },
  heroTitleNativeTablet: {
    fontSize: 46,
    lineHeight: 52,
    maxWidth: 430,
  },
  heroTitleNativeMobile: {
    fontSize: 34,
    lineHeight: 40,
    letterSpacing: -1.2,
    maxWidth: '100%',
  },
  heroDescriptionNative: {
    marginTop: 18,
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 28,
    color: '#45556F',
    maxWidth: 470,
  },
  heroActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    marginTop: 24,
  },
  heroActionsMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  ctaButton: {
    minWidth: 154,
    height: 50,
    paddingHorizontal: 22,
    borderRadius: 999,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ctaButtonCompact: {
    alignSelf: 'flex-start',
    marginTop: 24,
  },
  ctaButtonText: {
    fontFamily: 'poppins-medium',
  },
  statsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 34,
    gap: 16,
  },
  statsRowMobile: {
    flexDirection: 'column',
  },
  statCard: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    borderRadius: 22,
    padding: 20,
    borderWidth: 1,
    borderColor: '#E6ECF5',
    shadowColor: '#0F172A',
    shadowOpacity: 0.06,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 3,
  },
  statCardMobile: {
    width: '100%',
  },
  statValue: {
    fontFamily: 'poppins-medium',
    marginBottom: 8,
  },
  statLabel: {
    fontFamily: 'roboto-light',
    letterSpacing: 0.2,
  },
  heroVisual: {
    flex: 1.05,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  heroVisualMobile: {
    width: '100%',
  },
  heroArtwork: {
    width: '100%',
    minHeight: 500,
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  heroArtworkMobile: {
    minHeight: 360,
    marginTop: 14,
  },
  heroBlobLarge: {
    position: 'absolute',
    width: '54%',
    aspectRatio: 1,
    borderRadius: 999,
    backgroundColor: '#9864B5',
    top: 42,
    left: '16%',
    opacity: 0.98,
  },
  heroBlobTop: {
    position: 'absolute',
    width: '24%',
    aspectRatio: 1,
    borderRadius: 999,
    backgroundColor: '#7E68BB',
    top: 46,
    right: '14%',
  },
  heroBlobBottom: {
    position: 'absolute',
    width: '30%',
    aspectRatio: 1,
    borderRadius: 999,
    backgroundColor: '#7E68BB',
    bottom: 8,
    left: '24%',
  },
  heroImage: {
    width: '96%',
    height: 520,
    zIndex: 4,
    marginLeft: '12%',
  },
  heroFloatingBadge: {
    position: 'absolute',
    paddingHorizontal: 14,
    paddingVertical: 9,
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.92)',
    borderWidth: 1,
    borderColor: '#E6ECF5',
    shadowColor: '#0F172A',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 6 },
    elevation: 3,
    zIndex: 5,
  },
  heroFloatingBadgeTop: {
    top: 110,
    left: '6%',
  },
  heroFloatingBadgeMid: {
    top: 170,
    right: '6%',
  },
  heroFloatingBadgeBottom: {
    bottom: 82,
    left: '12%',
  },
  heroFloatingBadgeText: {
    fontFamily: 'poppins-medium',
    fontSize: 13,
    lineHeight: 18,
    color: '#1C2D5A',
  },
  heroImageMobile: {
    width: '92%',
    height: 280,
    marginLeft: 0,
  },
  heroImageTablet: {
    width: '98%',
    height: 420,
    marginLeft: '8%',
  },
  beliefBand: {
    marginHorizontal: 0,
    paddingHorizontal: 20,
    paddingVertical: 56,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1B2A4E',
  },
  beliefTitleNative: {
    fontFamily: 'poppins',
    fontSize: 34,
    lineHeight: 46,
    color: '#FFFFFF',
    textAlign: 'center',
    maxWidth: 1040,
  },
  beliefTitleNativeMobile: {
    fontSize: 22,
    lineHeight: 32,
    maxWidth: '100%',
  },
  beliefAccentNative: {
    fontFamily: 'poppins',
    fontSize: 34,
    lineHeight: 46,
    color: '#CC58E3',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 2,
  },
  beliefAccentNativeMobile: {
    fontSize: 22,
    lineHeight: 32,
  },
  featureSection: {
    backgroundColor: '#FFFFFF',
    paddingTop: 48,
    paddingBottom: 54,
    alignItems: 'center',
  },
  featureScroll: {
    width: '100%',
  },
  featureScrollContent: {
    paddingHorizontal: 34,
    gap: 18,
    alignItems: 'stretch',
  },
  featureScrollContentDesktop: {
    justifyContent: 'center',
  },
  featureCard: {
    width: 300,
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    paddingHorizontal: 28,
    paddingVertical: 32,
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderWidth: 1,
    borderColor: '#EEF2F7',
    shadowColor: '#0F172A',
    shadowOpacity: 0.05,
    shadowRadius: 16,
    shadowOffset: { width: 0, height: 8 },
    elevation: 2,
  },
  featureCardMobile: {
    width: 270,
    paddingHorizontal: 22,
    paddingVertical: 26,
  },
  featureIcon: {
    width: 76,
    height: 76,
  },
  featureTitleNative: {
    fontFamily: 'poppins-medium',
    fontSize: 28,
    lineHeight: 34,
    color: '#3A495F',
    marginTop: 22,
    marginBottom: 14,
    textAlign: 'center',
  },
  featureTitleNativeMobile: {
    fontSize: 24,
    lineHeight: 30,
  },
  featureDescriptionNative: {
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 31,
    color: '#45556F',
    textAlign: 'center',
  },
  featureDescriptionNativeMobile: {
    fontSize: 15,
    lineHeight: 28,
  },
  comparisonSection: {
    backgroundColor: '#1B2A4E',
    paddingHorizontal: 56,
    paddingVertical: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 20,
  },
  comparisonSectionMobile: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 32,
  },
  comparisonLeft: {
    flex: 1.08,
    maxWidth: 430,
  },
  comparisonLeftMobile: {
    width: '100%',
    maxWidth: '100%',
  },
  comparisonQuote: {
    fontFamily: 'poppins',
    fontSize: 24,
    lineHeight: 38,
    color: '#FFFFFF',
    fontWeight: '700',
  },
  comparisonQuoteMobile: {
    fontSize: 20,
    lineHeight: 32,
  },
  comparisonQuoteAccent: {
    color: '#CC58E3',
    fontWeight: '700',
  },
  comparisonProfile: {
    marginTop: 34,
    flexDirection: 'row',
    alignItems: 'center',
  },
  comparisonAvatar: {
    width: 92,
    height: 92,
    borderRadius: 999,
    backgroundColor: '#EDF1F8',
    borderWidth: 1,
    borderColor: '#E7E9EE',
    marginRight: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  comparisonAvatarText: {
    fontFamily: 'poppins',
    fontSize: 36,
    lineHeight: 40,
    color: '#1B2A4E',
    fontWeight: '700',
  },
  comparisonProfileText: {
    flex: 1,
  },
  comparisonName: {
    fontFamily: 'poppins',
    fontSize: 20,
    lineHeight: 28,
    color: '#FFFFFF',
    fontWeight: '700',
  },
  comparisonRole: {
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 24,
    color: '#FFFFFF',
    marginTop: 4,
  },
  comparisonDots: {
    marginTop: 24,
    flexDirection: 'row',
    alignItems: 'center',
  },
  comparisonDot: {
    width: 14,
    height: 14,
    borderRadius: 999,
    backgroundColor: '#FFFFFF',
    marginRight: 14,
    opacity: 0.88,
  },
  comparisonDotActive: {
    backgroundColor: '#7C69F6',
  },
  comparisonTable: {
    flex: 0.72,
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    overflow: 'hidden',
    minHeight: 286,
    maxWidth: 700,
  },
  comparisonTableMobile: {
    width: '100%',
  },
  comparisonHeaderRow: {
    flexDirection: 'row',
  },
  comparisonHeaderCell: {
    flex: 1,
    minHeight: 72,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  comparisonHeaderCellLight: {
    backgroundColor: '#FFFFFF',
  },
  comparisonHeaderCellGradient: {
    backgroundColor: '#CC58E3',
  },
  comparisonHeaderTextDark: {
    fontFamily: 'poppins',
    fontSize: 12,
    lineHeight: 18,
    color: '#3A495F',
    textAlign: 'center',
    fontWeight: '700',
  },
  comparisonHeaderTextLight: {
    fontFamily: 'poppins',
    fontSize: 12,
    lineHeight: 18,
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: '700',
  },
  comparisonBodyRow: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: '#E4E7EC',
  },
  comparisonBodyRowLast: {
    borderBottomWidth: 0,
  },
  comparisonBodyCell: {
    flex: 1,
    minHeight: 56,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
  },
  comparisonBodyCellRight: {
    borderLeftWidth: 1,
    borderLeftColor: '#E4E7EC',
  },
  comparisonCellIcon: {
    fontSize: 16,
    lineHeight: 16,
    marginRight: 8,
    fontWeight: '700',
  },
  comparisonCheck: {
    color: '#62D84E',
  },
  comparisonCross: {
    color: '#FF4747',
  },
  comparisonCellText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 11,
    lineHeight: 16,
    color: '#425469',
  },
  pricingSection: {
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 32,
    paddingTop: 56,
    paddingBottom: 64,
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  pricingFloatBadge: {
    position: 'absolute',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 999,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#E8ECF4',
    shadowColor: '#101828',
    shadowOpacity: 0.08,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 8 },
    elevation: 3,
    zIndex: 3,
  },
  pricingFloatBadgeLeft: {
    left: 78,
    top: 108,
  },
  pricingFloatBadgeRight: {
    right: 92,
    top: 156,
  },
  pricingFloatLabel: {
    fontFamily: 'poppins-medium',
    fontSize: 13,
    lineHeight: 18,
    color: '#344054',
  },
  pricingFloatOrb: {
    position: 'absolute',
    width: 138,
    height: 138,
    borderRadius: 999,
    backgroundColor: 'rgba(204,88,227,0.09)',
    zIndex: 1,
  },
  pricingFloatOrbTop: {
    right: -26,
    top: 28,
  },
  pricingFloatMini: {
    position: 'absolute',
    zIndex: 2,
  },
  pricingFloatMiniLeft: {
    left: 180,
    top: 210,
  },
  pricingFloatMiniRight: {
    right: 180,
    top: 288,
  },
  pricingFloatMiniInner: {
    width: 18,
    height: 18,
    borderRadius: 999,
    backgroundColor: 'rgba(124, 105, 246, 0.22)',
  },
  pricingFloatMiniInnerAlt: {
    backgroundColor: 'rgba(46, 144, 250, 0.18)',
    width: 22,
    height: 22,
  },
  pricingHeading: {
    fontFamily: 'poppins',
    fontSize: 40,
    lineHeight: 48,
    color: '#1B2A4E',
    fontWeight: '700',
    textAlign: 'center',
  },
  pricingHeadingMobile: {
    fontSize: 30,
    lineHeight: 38,
  },
  pricingGrid: {
    width: '100%',
    maxWidth: 1240,
    marginTop: 40,
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 22,
  },
  pricingGridMobile: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  pricingCard: {
    width: 360,
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    paddingHorizontal: 40,
    paddingVertical: 32,
    borderWidth: 1,
    borderColor: '#EAEFF5',
    shadowColor: '#101828',
    shadowOpacity: 0.08,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 3,
    position: 'relative',
  },
  pricingCardMobile: {
    width: '100%',
    maxWidth: 360,
  },
  pricingCardFeatured: {
    borderColor: '#E9D7FE',
    shadowColor: '#CC58E3',
    shadowOpacity: 0.14,
    shadowRadius: 22,
    shadowOffset: { width: 0, height: 14 },
    elevation: 5,
  },
  pricingFeaturedBadge: {
    position: 'absolute',
    top: 16,
    right: 18,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 999,
    backgroundColor: '#F9F5FF',
    borderWidth: 1,
    borderColor: '#E9D7FE',
  },
  pricingFeaturedBadgeText: {
    fontFamily: 'poppins-medium',
    fontSize: 11,
    lineHeight: 16,
    color: '#7C3AED',
  },
  pricingCardTitle: {
    fontFamily: 'poppins',
    fontSize: 28,
    lineHeight: 34,
    color: '#1B2A4E',
    fontWeight: '700',
  },
  pricingAmountRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginTop: 28,
  },
  pricingAmount: {
    fontFamily: 'poppins',
    fontSize: 52,
    lineHeight: 58,
    color: '#1B2A4E',
    fontWeight: '700',
  },
  pricingPeriod: {
    fontFamily: 'roboto-light',
    fontSize: 22,
    lineHeight: 28,
    color: '#1B2A4E',
    marginLeft: 10,
    marginBottom: 8,
  },
  pricingSubtitle: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 24,
    color: '#43556D',
    marginTop: 8,
  },
  pricingButton: {
    width: '100%',
    height: 52,
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 28,
  },
  pricingButtonText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 22,
    color: '#FFFFFF',
  },
  pricingList: {
    marginTop: 34,
  },
  pricingListItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 14,
  },
  pricingListIcon: {
    fontSize: 18,
    lineHeight: 18,
    color: '#62D84E',
    fontWeight: '700',
    marginRight: 12,
  },
  pricingListText: {
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 22,
    color: '#425469',
  },
  showcaseSection: {
    paddingHorizontal: 20,
    paddingBottom: 24,
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
  },
  showcaseSectionMobile: {
    flexDirection: 'column',
  },
  showcasePanel: {
    width: '48%',
    borderRadius: 30,
    padding: 30,
    overflow: 'hidden',
  },
  showcasePanelFull: {
    width: '100%',
  },
  showcasePanelDark: {
    backgroundColor: '#182B5B',
  },
  showcasePanelLight: {
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#E6ECF5',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  showcaseEyebrow: {
    fontFamily: 'poppins-medium',
    marginBottom: 14,
  },
  showcaseTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
  },
  showcaseDescription: {
    marginTop: 16,
    fontFamily: 'roboto-light',
  },
  benefitList: {
    marginTop: 28,
    gap: 14,
  },
  benefitItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  benefitDot: {
    width: 10,
    height: 10,
    borderRadius: 999,
    backgroundColor: '#60A5FA',
    marginTop: 7,
    marginRight: 12,
  },
  benefitText: {
    flex: 1,
    fontFamily: 'roboto-light',
  },
  productLogo: {
    width: 96,
    height: 96,
    marginBottom: 12,
  },
  productTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
  },
  productDescription: {
    marginTop: 14,
    fontFamily: 'roboto-light',
  },
  metricCard: {
    width: '100%',
    marginTop: 28,
    padding: 22,
    borderRadius: 20,
    backgroundColor: '#F6F9FF',
    borderWidth: 1,
    borderColor: '#E0E8F5',
  },
  metricLabel: {
    fontFamily: 'roboto-light',
    marginBottom: 8,
  },
  metricValue: {
    fontFamily: 'poppins-medium',
  },
  deviceSection: {
    backgroundColor: '#1B2A4E',
    paddingHorizontal: 48,
    paddingVertical: 24,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  deviceSectionMobile: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingTop: 28,
    paddingBottom: 40,
  },
  deviceImageWrap: {
    flex: 0.95,
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 24,
  },
  deviceImageWrapMobile: {
    width: '100%',
    paddingRight: 0,
    marginBottom: 18,
  },
  deviceImage: {
    width: '100%',
    maxWidth: 560,
    height: 360,
  },
  deviceImageMobile: {
    height: 240,
    maxWidth: 360,
  },
  deviceContent: {
    flex: 1,
    maxWidth: 540,
  },
  deviceContentMobile: {
    width: '100%',
    maxWidth: '100%',
  },
  deviceEyebrow: {
    fontFamily: 'poppins',
    fontSize: 28,
    lineHeight: 36,
    color: '#CC58E3',
    fontWeight: '700',
  },
  deviceEyebrowMobile: {
    fontSize: 22,
    lineHeight: 30,
  },
  deviceTitle: {
    fontFamily: 'poppins',
    fontSize: 38,
    lineHeight: 52,
    color: '#FFFFFF',
    fontWeight: '700',
    marginTop: 18,
  },
  deviceTitleMobile: {
    fontSize: 28,
    lineHeight: 38,
    marginTop: 12,
  },
  deviceActions: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 34,
  },
  deviceActionsMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    marginTop: 24,
    marginBottom: 6,
  },
  devicePrimaryButton: {
    borderRadius: 20,
    marginRight: 14,
    overflow: 'hidden',
  },
  deviceSecondaryButton: {
    borderRadius: 20,
    overflow: 'hidden',
  },
  deviceButtonTouch: {
    minWidth: 142,
    height: 52,
    paddingHorizontal: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  deviceButtonText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 20,
    color: '#FFFFFF',
  },
  devicePrimaryButtonMobile: {
    width: '100%',
    marginRight: 0,
    marginBottom: 12,
  },
  deviceSecondaryButtonMobile: {
    width: '100%',
    marginBottom:40
  },
  faqSection: {
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 42,
    paddingTop: 56,
    paddingBottom: 64,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 28,
  },
  faqSectionMobile: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingTop: 36,
    paddingBottom: 40,
  },
  faqContent: {
    flex: 1,
    maxWidth: 760,
  },
  faqContentMobile: {
    width: '100%',
    maxWidth: '100%',
  },
  faqHeading: {
    fontFamily: 'poppins',
    fontSize: 38,
    lineHeight: 46,
    color: '#1B2A4E',
    fontWeight: '700',
  },
  faqHeadingMobile: {
    fontSize: 30,
    lineHeight: 38,
  },
  faqList: {
    marginTop: 42,
  },
  faqItem: {
    borderBottomWidth: 1,
    borderBottomColor: '#D9DEE7',
    paddingVertical: 18,
  },
  faqQuestionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  faqQuestion: {
    flex: 1,
    fontFamily: 'poppins-medium',
    fontSize: 18,
    lineHeight: 28,
    color: '#111827',
    paddingRight: 18,
  },
  faqQuestionMobile: {
    fontSize: 16,
    lineHeight: 24,
  },
  faqToggle: {
    fontSize: 28,
    lineHeight: 28,
    color: '#111827',
    width: 24,
    textAlign: 'center',
  },
  faqAnswer: {
    marginTop: 14,
    maxWidth: 620,
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 28,
    color: '#6B7280',
  },
  faqAnswerMobile: {
    fontSize: 15,
    lineHeight: 24,
  },
  faqImageWrap: {
    flex: 0.72,
    alignItems: 'center',
    justifyContent: 'center',
  },
  faqImageWrapMobile: {
    width: '100%',
    marginTop: 28,
  },
  faqImage: {
    width: '100%',
    maxWidth: 500,
    height: 420,
  },
  faqImageMobile: {
    height: 280,
    maxWidth: 320,
  },
  drawerModal: {
    margin: 0,
    width: '100%',
    right: 0,
  },
  drawerWrap: {
    width: '50%',
    height: '100%',
    position: 'absolute',
    right: 0,
    top: 0,
  },
  drawerWrapMobile: {
    width: '100%',
  },
});
